/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const Contact = () => (
  <div id="tf-contact" className="text-center">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="section-title center">
            <h2><strong>Contact us</strong></h2>
            <div className="line"><hr /></div>
            <div className="clearfix" />
            <p className="intro"><em>We'd love to hear from you, and promise to get back to you either by 'phone or email as soon as possible.</em></p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <div className="row">
              <div className="col-md-4 col-sm-6 service">
                <i className="fa fa-laptop" />
                <h4><strong>Email</strong></h4>
                <p>Sales:<br /><a href="mailto:sales@nowatt.com"> sales@nowatt.com</a></p>
                <p>Support:<br /><a href="mailto:support@nowatt.com"> support@nowatt.com</a></p>
              </div>
              <div className="col-md-4 col-sm-6 service">
                <i className="fa fa-phone" />
                <h4><strong>Telephone</strong></h4>
                <p>+44 7873 124107</p>
              </div>
              <div className="col-md-4 col-sm-6 service">
                <i className="fa fa-pencil-square-o" />
                <h4><strong>Post</strong></h4>
                <p>NoWatt Ltd.<br />39 Oxford Street<br />Newbury<br />Berkshire RG14 1JG<br />United Kingdom</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
